import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, submit, startSubmit } from "redux-form";
import _ from "lodash";
import { Modal, Tabs, Tab } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import moment from "moment-timezone";
import {
  insertExhibitor,
  openExhibitorModal,
  loadExhibitorData,
  updateExhibitorImage,
  updateExhibitorFiles,
  filesChanged,
  updateExhibitorBanner,
  workingDynamicForm,
} from "ActionsExhibitors";
import { checkContentDashboardStatus } from "GeneralTabAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { fetchUserList } from "DashboardUserAction";
import {
  BASE_IMAGES_URL,
  NEW_IMAGE_PATH,
  COMMON_FAIL_MESSAGE,
  DATE_FORMAT,
  validateEmail,
  validateSocialMediaUrl,
  validatePhoneNumbers,
  maxLengthObjectFc,
  DATE_FORMAT_FNS,
  DISPLAY_LOCAL_DATE_FORMAT,
} from "Constants";
import { isEmpty } from "BaseFunctions";
import InlineCropper from "InlineCropper";
import { BaseComponent } from "BaseComponent";
import AllFilesDrop from "AllFilesDrop";
import AssociatedUsers from "./associated-users";
import { LABEL_POSITION_TOP } from "BaseComponent";
import LocaleStrings from "Languages";
import { parse, format, subDays } from "date-fns";

var MAXLENOBJ = {};
class AddExhibitor extends BaseComponent {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.formRef = React.createRef();
    this.state = { tabKey: 1, imagedata: "", active: false, update: true };
  }

  open() {
    this.setState({ tabKey: 1, imagedata: "", active: false });
    this.props.loadExhibitorData({});
    this.props.reset();
    this.props.openExhibitorModal({
      showModal: true,
      tabKey: this.state.tabKey,
    });
    this.props.workingDynamicForm({});
  }

  close() {
    var files = [
      { position: "file1", file: "", filename: "" },
      { position: "file2", file: "", filename: "" },
      { position: "file3", file: "", filename: "" },
      { position: "file4", file: "", filename: "" },
      { position: "file5", file: "", filename: "" },
    ];

    this.props.openExhibitorModal({
      showModal: false,
      tabKey: this.state.tabKey,
      imagedata: "",
    });
    this.setState({ tabKey: 1, imagedata: "", active: false });
    this.props.updateExhibitorFiles(files);
    this.props.reset();
    this.props.filesChanged({
      ischanged: false,
      groupfieldchanged: false,
      productimagechanged: false,
    });
    this.props.fetchUserList(this.props.session);
    this.props.workingDynamicForm({});
  }

  handleSelect(key) {
    this.props.openExhibitorModal({ showModal: true, tabKey: key });
  }

  submitFormOn = (e) => {
    this.props.dispatch(startSubmit("AddExhibitorForm"));

    this.formRef.current.saveImage(() => {
      this.props.dispatch(submit("AddExhibitorForm"));
    });
  };

  render() {
    var {
      handleSubmit,
      pristine,
      dirty,
      submitting,
      valid,
      submit,
      imagedata,
      bannerdata,
      filechanged,
    } = this.props;
    var edit = false;

    if (this.props.initialValues.exhibitorid) {
      edit = true;
    }

    var disabled = !(
      (dirty && valid) ||
      (edit && pristine && this.state.active)
    );

    if (
      edit &&
      ((imagedata && imagedata != "") ||
        (filechanged && filechanged.ischanged) ||
        (bannerdata && bannerdata != "") ||
        (filechanged && filechanged.productimagechanged) ||
        (filechanged && filechanged.groupfieldchanged))
    ) {
      disabled = false;
    }

    return (
      <div>
        <Button
          className="btn-custom-blue schedule-add-button"
          onClick={this.open.bind(this)}
        >
          {/* <i className="fa fa-plus i-custom-m" aria-hidden="true"/> Add Exhibitor */}
          <img
            style={{ paddingRight: 10, paddingBottom: 3 }}
            src="../../style/images/header-icons/plus.png"
          ></img>
          {LocaleStrings.exhibitor_addnew}
        </Button>
        <div>
          <Modal
            className="modal-container "
            show={this.props.showModal.showModal === true ? true : false}
            onHide={this.close}
            animation={true}
            keyboard={false}
            backdrop="static"
            dialogClassName="exhibitorModal"
            enforceFocus={false}
          >
            <form
              onSubmit={handleSubmit(submit)}
              encType="multipart/form-data"
              noValidate
            >
              <Modal.Header>
                <div className="import-modal-title">{`${
                  edit ? `Update` : `Add`
                } Exhibitor`}</div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.close()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Modal.Header>
              <Modal.Body>
                <Tabs
                  className="branding-tabs mt-0"
                  activeKey={this.props.showModal.tabKey}
                  onSelect={this.handleSelect}
                  id="uncontrolled-tab-example"
                >
                  <Tab eventKey={1} title="Basic Details">
                    <ExhibitorDetailsForm
                      {...this.props}
                      exhibitor={this.props.initialValues}
                      session={this.props.session}
                      onImageChange={(img) => this.setState({ active: true })}
                      ref={this.formRef}
                    />
                  </Tab>
                  <Tab eventKey={2} title="Additional Details">
                    <OtherDetailsForm {...this.props} />
                  </Tab>
                  <Tab eventKey={3} title="User Permission">
                    <AssociatedUsers {...this.props} />
                  </Tab>

                  {/* Below code is comented by me on 24-11-2020 as now we are not uploading the file separately */}
                  {/* <Tab eventKey={2} title="Contact Details"><ExhibitorContactForm/></Tab>
                  <Tab eventKey={4} title="File Upload"><ExhibitorFileUpload/></Tab> */}
                </Tabs>
              </Modal.Body>
              <Modal.Footer>
                <Button className="btn btn-custom-white" onClick={this.close}>
                  {LocaleStrings.exhibitor_closebutton}
                </Button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  type="button"
                  loading={submitting}
                  onClick={this.submitFormOn}
                  disabled={disabled}
                >
                  {LocaleStrings.exhibitor_savechanges}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};
  var requiredFields = ["name"];
  var maxLengthFields = ["name", "booth", "about"];
  requiredFields.forEach((field) => {
    if (!values[field] || values[field].trim() === "") {
      errors[field] = LocaleStrings.exhibitor_validation_required;
    }
    // This validation is not required (Changed by vinay suggested by Baishakhee, as some of exhibitor having name with special char, 25-02-2020)

    // if (field === 'name') {
    //   if (values[field] && !(/^[a-zA-Z0-9- ]*$/.test(values[field]))) {
    //     errors[field] = 'Name can not contain special characters';
    //   }
    // }
  });

  if (values.email) {
    if (!validateEmail(values.email)) {
      errors.email = LocaleStrings.exhibitor_validation_email_invalid;
    }
  }
  if (values.twitter) {
    if (!validateSocialMediaUrl(values.twitter)) {
      errors.twitter = LocaleStrings.invalid_twitter_url;
    }
  }
  if (values.linkedin) {
    if (!validateSocialMediaUrl(values.linkedin)) {
      errors.linkedin = LocaleStrings.invalid_linkedin_url;
    }
  }
  if (values.facebook) {
    if (!validateSocialMediaUrl(values.facebook)) {
      errors.facebook = LocaleStrings.invalid_facebook_url;
    }
  }
  if (values.instagram) {
    if (!validateSocialMediaUrl(values.instagram)) {
      errors.instagram = LocaleStrings.invalid_instagram_url;
    }
  }
  if (values.weblink) {
    if (!validateSocialMediaUrl(values.weblink)) {
      errors.weblink = LocaleStrings.invalid_url;
    }
  }
  if (values.phone) {
    if (!validatePhoneNumbers(values.phone)) {
      errors.phone = LocaleStrings.exhibitor_validation_phone_invalid;
    } else if (values.phone.length < 10) {
      errors.phone = LocaleStrings.exhibitor_validation_phone_invalid;
    }
  }

  /*** Max Length Validation ***/
  maxLengthFields.forEach((field) => {
    if (values[field] && MAXLENOBJ) {
      if (values[field].length > MAXLENOBJ[field]) {
        errors[field] = LocaleStrings.max_characters_left + MAXLENOBJ[field];
      }
    }
  });

  return errors;
}

function onFormSubmit(values, dispatch, props) {
  var {
    session,
    imagedata,
    bannerdata,
    filechanged,
    exhibitorFilesList,
    settingData,
    ticketList,
    toEdit,
    exhibitorWorkingDynamicForm,
  } = props;
  // console.log("values :- ", values);

  if (values.hasOwnProperty("facebook")) {
    values["facebook"] = values.facebook.replaceAll(/\s/g, "");
  }
  if (values.hasOwnProperty("linkedin")) {
    values["linkedin"] = values.linkedin.replaceAll(/\s/g, "");
  }
  if (values.hasOwnProperty("twitter")) {
    values["twitter"] = values.twitter.replaceAll(/\s/g, "");
  }
  var eventForm =
    settingData &&
    settingData.length > 0 &&
    settingData[0].event_forms_by_exhibitorformid
      ? JSON.parse(settingData[0].event_forms_by_exhibitorformid.formjson)
      : [];
  var eventFormID =
    settingData && settingData.length > 0
      ? settingData[0].exhibitorformid
      : null;
  var savedForm =
    values && values.responses ? JSON.parse(values.responses) : [];

  if (toEdit && values.comesfrom == "ticket") {
    var matchedTicket = _.filter(ticketList, (ticket) => {
      return ticket.id == values.ticketid;
    });

    if (matchedTicket.length > 0 && matchedTicket[0].event_forms_by_formid) {
      eventForm = JSON.parse(matchedTicket[0].event_forms_by_formid.formjson);
      eventFormID = matchedTicket[0].formid;
    }
  }

  var array = [];
  if (eventForm.length > 0) {
    _.map(eventForm, (form, index) => {
      var name = form.name;
      var formKey = form.key;

      if (values.hasOwnProperty(name)) {
        if (formKey === "datepicker") {
          let date =
            typeof values[name] === "string"
              ? moment(values[name], DISPLAY_LOCAL_DATE_FORMAT).format(
                  "YYYY-MM-DD"
                )
              : moment(values[name]).format("YYYY-MM-DD");

          form.value = date;
        } else {
          form.value = values[name];
        }
        array.push(form);
      } else {
        // form.name = form.key === 'label' || form.key === 'paragraph' ? '' : name;
        form.value = "";
        if (formKey === "checkboxes") {
          form.value = [];
        } else if (formKey == "file") {
          // var checkFiles = _.filter(savedForm, (obj) => {
          //   return obj.key === "file" && obj.name === name;
          // });
          // form.value = checkFiles.length > 0 ? checkFiles[0].value : [];

          var checkNewFiles = _.filter(
            exhibitorWorkingDynamicForm.workingEventForm,
            (obj) => {
              return obj.key === "file" && obj.name === name;
            }
          );

          form.value =
            checkNewFiles.length > 0 ? checkNewFiles[0].fileArray : [];
        } else if (formKey == "group") {
          // var checkGroup = _.filter(savedForm, obj => {return obj.key === 'group' && obj.name === name});

          // form.value = checkGroup.length > 0 ? checkGroup.value : [];

          var checkNewGroup = _.filter(
            exhibitorWorkingDynamicForm.workingEventForm,
            (obj) => {
              return obj.key === "group" && obj.name === name;
            }
          );
          // console.log("checkNewGroup :- ", checkNewGroup);

          form.value =
            checkNewGroup.length > 0 ? checkNewGroup[0].recordArray : [];
        }
        array.push(form);
      }
    });
  }
  // console.log("array :- ", array);

  // debugger;

  values.name = values.name.trim();
  values.responses = JSON.stringify(array);
  values.formid = eventFormID;
  if (values.booth) {
    values.booth = values.booth.trim();
  }
  if (values.position) {
    values.position = values.position.trim();
  }
  if (values.email) {
    values.email = values.email.trim();
  }
  if (values.phone) {
    values.phone = values.phone.trim();
  }
  if (values.weblink) {
    values.weblink = values.weblink.trim();
  }
  if (values.facebook) {
    values.facebook = values.facebook.trim();
  }
  if (values.linkedin) {
    values.linkedin = values.linkedin.trim();
  }
  if (values.twitter) {
    values.twitter = values.twitter.trim();
  }

  var exhibitor = props.initialValues;
  var data = { ...values };

  if (imagedata === "" || imagedata === "removed") {
    if (imagedata === "removed") {
      data.profileimage = null;
      data.profilethumbimage = null;
    }

    imagedata = null;
  }
  if (bannerdata === "" || bannerdata === "removed") {
    if (bannerdata === "removed") {
      data.bannerimage = null;
    }

    bannerdata = null;
  }

  /*if (this.props.initialValues.exhibitorid && this.state.active === false) {
    // in edit mode and image is not changed
  } else {*/

  return new Promise((resolve, reject) => {
    // Below code is comented by Vinay on 24-11-2020 as now we are not uploading the file separately and banner is added
    // return props.insertExhibitor(session,data,exhibitor,imagedata,filechanged,exhibitorFilesList,(result)=>{
    return props.insertExhibitor(
      session,
      data,
      exhibitor,
      imagedata,
      bannerdata,
      filechanged,
      exhibitorWorkingDynamicForm,
      (result) => {
        if (result.error === 1) {
          props.stopSubmit("AddExhibitorForm");
          props.showError(COMMON_FAIL_MESSAGE);
          return reject(result.error);
        } else if (result.error === 2) {
          props.stopSubmit("AddExhibitorForm");
          props.showError("There was an error uploading image!");
          return reject(result.error);
        } else if (result.error === 4) {
          props.stopSubmit("AddExhibitorForm");
          props.showError(
            "Exhibitor updated successfully, But product is not updated!"
          );
          return reject();
        } else {
          props.reset();
          props.checkContentDashboardStatus(props.session);
          props.finishOperationsCallback();
          setTimeout(() => {
            props.stopSubmit("AddExhibitorForm");
            props.showSuccess("Exhibitor updated successfully");
            props.openExhibitorModal({
              showModal: false,
              tabKey: 1,
              imagedata: "",
            });
            return resolve(result);
          }, 500);
        }
      }
    );
  });
}

function mapStateToProps(state) {
  var toEdit = !isEmpty(state.exhibitor);
  var initVals = {};
  var permittedusers = "";

  if (toEdit) {
    initVals = state.exhibitor;

    if (initVals.appuser_by_exhibitoridfk.length > 0) {
      permittedusers = JSON.stringify(initVals.appuser_by_exhibitoridfk);
    }

    let eventForm =
      state.SettingData &&
      state.SettingData.resource &&
      state.SettingData.resource.length > 0 &&
      state.SettingData.resource[0].event_forms_by_exhibitorformid
        ? JSON.parse(
            state.SettingData.resource[0].event_forms_by_exhibitorformid
              .formjson
          )
        : [];
    let savedForm = initVals.responses ? JSON.parse(initVals.responses) : [];
    if (initVals.comesfrom == "ticket") {
      if (state.allTicketList && state.allTicketList.resource) {
        var matchedTicket = _.filter(state.allTicketList.resource, (ticket) => {
          return ticket.id == initVals.ticketid;
        });

        if (
          matchedTicket.length > 0 &&
          matchedTicket[0].event_forms_by_formid
        ) {
          eventForm = JSON.parse(
            matchedTicket[0].event_forms_by_formid.formjson
          );
        }
      }
    }

    if (savedForm && savedForm.length > 0) {
      _.map(eventForm, (form, index) => {
        var name = form.name;
        var formKey = form.key;

        var check = [];
        if (name != "isnetworking") {
          check = _.filter(savedForm, function (saved) {
            return saved.name === name;
          });
        }

        if (
          check &&
          check.length > 0 &&
          check[0].value &&
          name == check[0].name
        ) {
          // Set the group' value format
          if (formKey === "group") {
            if (check[0].type === "products") {
              var productimagesArr = [];
              var productcateArr = [];
              var productsubcateArr = [];
              var producttitleArr = [];
              var productinfoArr = [];
              _.map(check[0].value, (obj, key) => {
                productimagesArr.push(obj.productimages);
                productcateArr.push(
                  obj.productcategory ? obj.productcategory : ""
                );
                productsubcateArr.push(
                  obj.productsubcategory ? obj.productsubcategory : ""
                );
                producttitleArr.push(obj.producttitle);
                productinfoArr.push(obj.productinfo);
              });

              initVals["productimages"] = productimagesArr;
              initVals["productcategory"] = productcateArr;
              initVals["productsubcategory"] = productsubcateArr;
              initVals["producttitle"] = producttitleArr;
              initVals["productinfo"] = productinfoArr;
            } else if (check[0].type === "coupons") {
              var coupontitleArr = [];
              var couponaboutArr = [];
              var couponecodeArr = [];
              var couponvalidtillArr = [];
              _.map(check[0].value, (obj, key) => {
                coupontitleArr.push(obj.coupontitle);
                couponaboutArr.push(obj.couponabout);
                couponecodeArr.push(obj.couponecode);
                couponvalidtillArr.push(obj.couponvalidtill);
              });

              initVals["coupontitle"] = coupontitleArr;
              initVals["couponabout"] = couponaboutArr;
              initVals["couponecode"] = couponecodeArr;
              initVals["couponvalidtill"] = couponvalidtillArr;
            } else if (check[0].type === "deals") {
              var dealtitleArr = [];
              var dealaboutArr = [];
              var dealvalidtillArr = [];
              _.map(check[0].value, (obj, key) => {
                dealtitleArr.push(obj.dealtitle);
                dealaboutArr.push(obj.dealabout);
                dealvalidtillArr.push(obj.dealvalidtill);
              });

              initVals["dealtitle"] = dealtitleArr;
              initVals["dealabout"] = dealaboutArr;
              initVals["dealvalidtill"] = dealvalidtillArr;
            }
          } else {
            initVals[check[0].name] = check[0].value;
          }

          // Below if conditions are used to check if any fields keytype has been changed, so accordingly storing the value to changed keytype field, so saved value will not lost
          // Checking if dropdown, radio saved value changed to input, number, textarea
          if (
            (formKey === "textinput" ||
              formKey === "numberinput" ||
              formKey == "textarea") &&
            (check[0].key === "dropdown" || check[0].key === "radiobuttons")
          ) {
            var options = check[0].options;
            var checkValue = _.filter(options, function (opt) {
              return (
                opt.text === check[0].value || opt.value === check[0].value
              );
            });

            if (checkValue && checkValue.length > 0) {
              initVals[check[0].name] = checkValue[0].text;
            } else {
              initVals[check[0].name] = "";
            }
          }

          // Checking if checkboxes saved value changed to input, number, textarea
          if (
            (formKey === "textinput" ||
              formKey === "numberinput" ||
              formKey == "textarea") &&
            check[0].key === "checkboxes"
          ) {
            var options = check[0].options;
            var checkBoxSavedValue = check[0].value;

            var displayValue = [];
            _.map(checkBoxSavedValue, (box, index) => {
              var checkValue = _.filter(options, function (opt) {
                return opt.text === box || opt.value === box;
              });

              if (checkValue && checkValue.length > 0) {
                displayValue.push(checkValue[0].text);
              }
            });

            if (displayValue.length > 0) {
              initVals[check[0].name] = displayValue.join(",");
            } else {
              initVals[check[0].name] = "";
            }
          }

          // Checking if input, number, textarea saved value changed to dropdown, radio
          if (
            (formKey === "dropdown" || formKey === "radiobuttons") &&
            (check[0].key === "textinput" ||
              check[0].key === "numberinput" ||
              check[0].key === "textarea")
          ) {
            var options = form.options;
            var checkValue = _.filter(options, function (opt) {
              return (
                opt.text === check[0].value || opt.value === check[0].value
              );
            });

            if (checkValue && checkValue.length > 0) {
              initVals[name] = checkValue[0].value;
            } else {
              initVals[name] = "";
            }
          }

          // Checking if input, number, textarea saved value changed to checkboxes
          if (
            formKey === "checkboxes" &&
            (check[0].key === "textinput" ||
              check[0].key === "numberinput" ||
              check[0].key === "textarea")
          ) {
            var options = form.options;
            var checkBoxSavedValue = check[0].value.split(",");
            var displayValue = [];
            _.map(checkBoxSavedValue, (box, index) => {
              var checkValue = _.filter(options, function (opt) {
                return opt.text === box || opt.value === box;
              });

              if (checkValue && checkValue.length > 0) {
                displayValue.push(checkValue[0].value);
              }
            });

            if (displayValue.length > 0) {
              initVals[name] = displayValue;
            } else {
              initVals[name] = "";
            }
          }

          // Checking if dropdown saved value changed to radiobuttons or vice versa
          if (
            (formKey === "dropdown" && check[0].key === "radiobuttons") ||
            (formKey === "radiobuttons" && check[0].key === "dropdown")
          ) {
            var options = check[0].options;
            var checkValue = _.filter(options, function (opt) {
              return (
                opt.text === check[0].value || opt.value === check[0].value
              );
            });

            if (checkValue && checkValue.length > 0) {
              initVals[check[0].name] = checkValue[0].value;
            } else {
              initVals[check[0].name] = "";
            }
          }

          // Checking if dropdown, radiobuttons saved value changed to checkboxes
          if (
            formKey === "checkboxes" &&
            (check[0].key === "dropdown" || check[0].key === "radiobuttons")
          ) {
            var options = form.options;
            var displayValue = [];
            var checkValue = _.filter(options, function (opt) {
              return (
                opt.text === check[0].value || opt.value === check[0].value
              );
            });
            if (checkValue && checkValue.length > 0) {
              displayValue.push(checkValue[0].value);
            }

            if (displayValue.length > 0) {
              initVals[name] = displayValue;
            } else {
              initVals[name] = "";
            }
          }

          // Checking if checkboxes saved value changed to dropdown, radiobuttons
          if (
            (formKey === "dropdown" || formKey === "radiobuttons") &&
            check[0].key === "checkboxes"
          ) {
            var options = form.options;
            var checkBoxSavedValue = check[0].value;

            var displayValue = "";
            var matched = false;
            for (let index = 0; index < checkBoxSavedValue.length; index++) {
              const box = checkBoxSavedValue[index];
              var checkValue = _.filter(options, function (opt) {
                return opt.text === box || opt.value === box;
              });

              if (checkValue && checkValue.length > 0) {
                matched = true;
                displayValue = checkValue[0].value;
                break;
              }
            }

            if (matched && displayValue != "") {
              initVals[check[0].name] = displayValue;
            } else {
              initVals[check[0].name] = "";
            }
          }
        }
      });
    }
    initVals = { ...initVals, permittedusers: permittedusers };
  } else {
    initVals = { permittedusers: permittedusers };
  }

  return {
    session: state.session,
    toEdit,
    initialValues: initVals,
    showModal: state.exhibitorModal,
    imagedata: state.exhibitorImage,
    bannerdata: state.exhibitorBanner,
    filechanged: state.exhibitorFilesChanged,
    exhibitorFilesList: state.exhibitorFilesList,
    settingData: state.SettingData.resource,
    ticketList: state.allTicketList.resource,
    exhibitorWorkingDynamicForm: state.exhibitorWorkingDynamicForm,
    productCategories: state.exhibitorProductCategories,
    productSubCategories: state.exhibitorProductSubCategories,
  };
}

export default connect(mapStateToProps, {
  insertExhibitor,
  openExhibitorModal,
  updateExhibitorImage,
  loadExhibitorData,
  showError,
  showSuccess,
  checkContentDashboardStatus,
  updateExhibitorFiles,
  filesChanged,
  fetchUserList,
  updateExhibitorBanner,
  workingDynamicForm,
})(
  reduxForm({
    validate,
    form: "AddExhibitorForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    onSubmit: onFormSubmit,
  })(AddExhibitor)
);

class ExhibitorDetailsForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { imagePreviewUrl: "", bannerPreviewUrl: "" };
    this.onImageSave = this.onImageSave.bind(this);
    this.cropperRef = React.createRef();
    this.cropperBannerRef = React.createRef();
    this.props.updateExhibitorImage("");
    this.props.updateExhibitorBanner("");
  }

  onImageSave = (img) => {
    this.setState({ imagePreviewUrl: img });
    this.props.updateExhibitorImage(img == "" ? "removed" : img);
  };

  onImageChange = (imageAvailable) => {
    if (imageAvailable !== undefined) this.setState({ imageAvailable });
  };

  onBannerSave = (img) => {
    this.setState({ bannerPreviewUrl: img });
    this.props.updateExhibitorBanner(img == "" ? "removed" : img);
  };

  onBannerChange = (bannerAvailable) => {
    if (bannerAvailable !== undefined) this.setState({ bannerAvailable });
  };

  saveImage = (callback) => {
    if (this.state.imageAvailable) {
      this.cropperRef.current.saveImage(callback);
    } else if (this.state.bannerAvailable) {
      this.cropperBannerRef.current.saveImage(callback);
    } else {
      callback();
    }
  };

  render() {
    let { imagePreviewUrl, bannerPreviewUrl } = this.state;
    var { exhibitor } = this.props;
    if (exhibitor) {
      imagePreviewUrl = exhibitor.profileimage
        ? `${BASE_IMAGES_URL}/${exhibitor.profileimage}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`
        : "";
      bannerPreviewUrl = exhibitor.bannerimage
        ? `${BASE_IMAGES_URL}/${exhibitor.bannerimage}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`
        : "";
    }

    return (
      <div className="exhibitordetailsform">
        <Field
          name="name"
          label={LocaleStrings.exhibitor_label_name}
          placeholder={LocaleStrings.exhibitor_placeholder_exhibitor_name}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
          maxlength={MAXLENOBJ.name ? MAXLENOBJ.name : ""}
        />
        <Field
          name="booth"
          label={LocaleStrings.exhibitor_label_booth}
          placeholder={LocaleStrings.exhibitor_placeholder_booth}
          type="text"
          component={this.renderFieldText}
          mandatory="false"
          labelposition={LABEL_POSITION_TOP}
          maxlength={MAXLENOBJ.booth ? MAXLENOBJ.booth : ""}
        />
        <div className="form-group row">
          <label className="control-label-top col-sm-12">
            {LocaleStrings.exhibitor_banner}
          </label>
          <div className="col-sm-12 col-sm-offset-0 imgPreview">
            <InlineCropper
              width={1132}
              height={736}
              border={10}
              onImageSave={this.onBannerSave}
              onImageChange={this.onBannerChange}
              imagepath={bannerPreviewUrl}
              ref={this.cropperBannerRef}
            />
            <div className="image-subtitle-info">
              {LocaleStrings.exhibitor_image_subtitle_info}
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="control-label-top col-sm-12">Logo</label>
          <div className="col-sm-12 col-sm-offset-0 imgPreview">
            <InlineCropper
              width={600}
              height={600}
              border={10}
              onImageSave={this.onImageSave}
              onImageChange={this.onImageChange}
              imagepath={imagePreviewUrl}
              ref={this.cropperRef}
            />
            <div className="image-subtitle-info">
              {LocaleStrings.exhibitor_image_subtitle_info300}
            </div>
          </div>
        </div>

        <Field
          name="about"
          label={LocaleStrings.exhibitor_label_about}
          placeholder="Enter about exhibitor"
          mandatory="false"
          component={this.renderFieldTextarea}
          maxlength={MAXLENOBJ.about ? MAXLENOBJ.about : ""}
          labelposition={LABEL_POSITION_TOP}
        />
        {/*<Field
          name="note"
          label="Notes (optional)"
          placeholder="Add some notes"
          component={this.renderRichTextareaWithLabelTinymce}
          mandatory='false'
          type="minimal"
          labelposition={LABEL_POSITION_TOP}
        />*/}
      </div>
    );
  }
}

class OtherDetailsForm extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = { submitting: false };

    let { initialValues, toEdit, settingData, ticketList } = props;
    let eventForm =
      settingData &&
      settingData.length > 0 &&
      settingData[0].event_forms_by_exhibitorformid
        ? JSON.parse(settingData[0].event_forms_by_exhibitorformid.formjson)
        : [];
    let savedForm =
      initialValues && initialValues.responses
        ? JSON.parse(initialValues.responses)
        : [];

    if (toEdit && initialValues.comesfrom == "ticket") {
      var matchedTicket = _.filter(ticketList, (ticket) => {
        return ticket.id == initialValues.ticketid;
      });

      if (matchedTicket.length > 0 && matchedTicket[0].event_forms_by_formid) {
        eventForm = JSON.parse(matchedTicket[0].event_forms_by_formid.formjson);
      }
    }

    let workingEventForm = eventForm;
    _.map(eventForm, (item, index) => {
      var check = _.filter(savedForm, function (saved) {
        return saved.name === item.name;
      });
      if (item.key === "file") {
        if (savedForm.length > 0) {
          if (
            check &&
            check.length > 0 &&
            check[0].value &&
            check[0].value.length > 0
          ) {
            var exhistingFileArray = [];
            _.map(check[0].value, (file) => {
              var f1 = file.split("/").pop();
              var f2 = f1.substr(0, f1.lastIndexOf("_"));
              var ext = f1.split(".").pop();

              var fileName = f2 + "." + ext;
              var fileObj = { file: file, filename: fileName };

              exhistingFileArray.push(fileObj);
            });

            item.fileArray = exhistingFileArray;
          } else {
            item.fileArray = [""];
          }
        } else {
          item.fileArray = [""];
        }
      } else if (item.key === "group") {
        if (item.type === "products") {
          var proObj = {
            productimages: "",
            productcategory: "",
            productsubcategory: "",
            producttitle: "",
            productinfo: "",
          };
          var proArrVal = [proObj];

          if (
            check &&
            check.length > 0 &&
            check[0].value &&
            check[0].value.length > 0
          ) {
            proArrVal = check[0].value;
          }
          item.recordArray = proArrVal;
        } else if (item.type === "coupons") {
          var couObj = {
            coupontitle: "",
            couponabout: "",
            couponecode: "",
            couponvalidtill: "",
          };
          var couArrVal = [couObj];

          if (
            check &&
            check.length > 0 &&
            check[0].value &&
            check[0].value.length > 0
          ) {
            couArrVal = check[0].value;
          }
          item.recordArray = couArrVal;
        } else if (item.type === "deals") {
          var dealObj = { dealtitle: "", dealabout: "", dealvalidtill: "" };
          var dealArrVal = [dealObj];

          if (
            check &&
            check.length > 0 &&
            check[0].value &&
            check[0].value.length > 0
          ) {
            dealArrVal = check[0].value;
          }
          item.recordArray = dealArrVal;
        }
      }

      workingEventForm[index] = item;
    });

    this.props.workingDynamicForm({ workingEventForm: workingEventForm });
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history); // filter This form name object With route
  }
  // componentWillReceiveProps(nextProps) {

  //   if (nextProps.submitting && this.state.submitting != nextProps.submitting) {
  //     let { initialValues, toEdit, settingData, ticketList } = nextProps;
  //     let eventForm =
  //       settingData &&
  //       settingData.length > 0 &&
  //       settingData[0].event_forms_by_exhibitorformid
  //         ? JSON.parse(settingData[0].event_forms_by_exhibitorformid.formjson)
  //         : [];
  //     let savedForm =
  //       initialValues && initialValues.responses
  //         ? JSON.parse(initialValues.responses)
  //         : [];

  //     if (toEdit && initialValues.comesfrom == "ticket") {
  //       var matchedTicket = _.filter(ticketList, (ticket) => {
  //         return ticket.id == initialValues.ticketid;
  //       });

  //       if (
  //         matchedTicket.length > 0 &&
  //         matchedTicket[0].event_forms_by_formid
  //       ) {
  //         eventForm = JSON.parse(
  //           matchedTicket[0].event_forms_by_formid.formjson
  //         );
  //       }
  //     }

  //     let workingEventForm = eventForm;
  //     _.map(eventForm, (item, index) => {
  //       var check = _.filter(savedForm, function (saved) {
  //         return saved.name === item.name;
  //       });
  //       if (item.key === "file") {
  //         if (savedForm.length > 0) {
  //           if (
  //             check &&
  //             check.length > 0 &&
  //             check[0].value &&
  //             check[0].value.length > 0
  //           ) {
  //             var exhistingFileArray = [];
  //             _.map(check[0].value, (file) => {
  //               var f1 = file.split("/").pop();
  //               var f2 = f1.substr(0, f1.lastIndexOf("_"));
  //               var ext = f1.split(".").pop();

  //               var fileName = f2 + "." + ext;
  //               var fileObj = { file: file, filename: fileName };

  //               exhistingFileArray.push(fileObj);
  //             });

  //             item.fileArray = exhistingFileArray;
  //           } else {
  //             item.fileArray = [""];
  //           }
  //         } else {
  //           item.fileArray = [""];
  //         }
  //       } else if (item.key === "group") {
  //         if (item.type === "products") {
  //           var proObj = {
  //             productimages: "",
  //             productcategory: "",
  //             productsubcategory: "",
  //             producttitle: "",
  //             productinfo: "",
  //           };
  //           var proArrVal = [proObj];

  //           if (
  //             check &&
  //             check.length > 0 &&
  //             check[0].value &&
  //             check[0].value.length > 0
  //           ) {
  //             proArrVal = check[0].value;
  //           }
  //           item.recordArray = proArrVal;
  //         } else if (item.type === "coupons") {
  //           var couObj = {
  //             coupontitle: "",
  //             couponabout: "",
  //             couponecode: "",
  //             couponvalidtill: "",
  //           };
  //           var couArrVal = [couObj];

  //           if (
  //             check &&
  //             check.length > 0 &&
  //             check[0].value &&
  //             check[0].value.length > 0
  //           ) {
  //             couArrVal = check[0].value;
  //           }
  //           item.recordArray = couArrVal;
  //         } else if (item.type === "deals") {
  //           var dealObj = { dealtitle: "", dealabout: "", dealvalidtill: "" };
  //           var dealArrVal = [dealObj];

  //           if (
  //             check &&
  //             check.length > 0 &&
  //             check[0].value &&
  //             check[0].value.length > 0
  //           ) {
  //             dealArrVal = check[0].value;
  //           }
  //           item.recordArray = dealArrVal;
  //         }
  //       }

  //       workingEventForm[index] = item;
  //     });

  //     this.props.workingDynamicForm({ workingEventForm: workingEventForm });
  //     this.setState({ submitting: nextProps.submitting });
  //   } else {

  //     this.setState({ submitting: nextProps.submitting });
  //   }
  // }

  // Files field section start
  onFilesDrop = (index, name, files) => {
    let { exhibitorWorkingDynamicForm } = this.props;

    var checkEventFormFile = _.filter(
      exhibitorWorkingDynamicForm.workingEventForm,
      (obj) => {
        return obj.key === "file" && obj.name === name;
      }
    );
    // var findIndex = _.findIndex(exhibitorWorkingDynamicForm.workingEventForm, obj => { return obj.key === 'file' && obj.name === name});

    checkEventFormFile[0].fileArray[index] = files;

    this.props.workingDynamicForm(exhibitorWorkingDynamicForm);

    this.setState({ update: !this.state.update }); // Don't remove [you need this to render dom [redux update do not render dom in react 18]]
  };

  onFileAvailable = (available) => {
    let { filechanged } = this.props;
    // this.props.filesChanged({ischanged: available});

    this.props.filesChanged({
      ischanged: available,
      groupfieldchanged: filechanged.groupfieldchanged
        ? filechanged.groupfieldchanged
        : false,
      productimagechanged: filechanged.productimagechanged
        ? filechanged.productimagechanged
        : false,
    });
  };

  handleFileArray = (action, index, name) => {
    let { exhibitorWorkingDynamicForm, filechanged } = this.props;

    var checkEventFormFile = _.filter(
      exhibitorWorkingDynamicForm.workingEventForm,
      (obj) => {
        return obj.key === "file" && obj.name === name;
      }
    );

    // var findIndex = _.findIndex(exhibitorWorkingDynamicForm.workingEventForm, obj => { return obj.key === 'file' && obj.name === name});
    var newFileArray = checkEventFormFile[0].fileArray;

    if (action === "add") {
      newFileArray.push("");
    } else {
      _.pullAt(newFileArray, index);
    }

    this.props.workingDynamicForm(exhibitorWorkingDynamicForm);
    // this.props.filesChanged({ischanged: true});
    this.props.filesChanged({
      ischanged: true,
      groupfieldchanged: filechanged.groupfieldchanged
        ? filechanged.groupfieldchanged
        : false,
      productimagechanged: filechanged.productimagechanged
        ? filechanged.productimagechanged
        : false,
    });

    this.setState({ update: !this.state.update }); // Don't remove [you need this to render dom [redux update do not render dom in react 18]]
  };

  renderFiles = (accept, name) => {
    let { exhibitorWorkingDynamicForm } = this.props;

    var fileArray = [""];
    var maxfile = 1;
    var existingFilesCount = 1;
    if (
      exhibitorWorkingDynamicForm &&
      exhibitorWorkingDynamicForm.workingEventForm &&
      exhibitorWorkingDynamicForm.workingEventForm.length > 0
    ) {
      var checkEventFormFile = _.filter(
        exhibitorWorkingDynamicForm.workingEventForm,
        (obj) => {
          return obj.key === "file" && obj.name === name;
        }
      );

      fileArray = checkEventFormFile[0].fileArray;
      maxfile = checkEventFormFile[0].maxupload;
      existingFilesCount = fileArray.length;
    }

    return _.map(fileArray, (item, index) => {
      var filePreview = "";
      var fileName = "";
      var fileOld = true;

      // This is added because when data is getting saved that time 'fileArray' is not containing object data
      // if ((typeof item === "string" || item instanceof String) && item != "") {
      //   filePreview = `${BASE_IMAGES_URL}/${item}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      // }

      if (item && item.file) {
        var file = item.file;
        fileName = item.filename;
        filePreview = `${BASE_IMAGES_URL}/${file}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
        fileOld = true;
        var n = file.search(";base64,");
        if (n > 0) {
          fileOld = false;
          filePreview = file;
        }
      }

      return (
        <div
          className="col-md-4"
          key={`key-${index}`}
          style={{ display: "flex", marginTop: "10px" }}
        >
          <AllFilesDrop
            key={`key-${index}`}
            width={225}
            height="auto"
            onFileSave={this.onFilesDrop.bind(this, index, name)}
            filepath={filePreview}
            onFileChnageLocally={this.onFileAvailable}
            fileName={fileName}
            fileOld={fileOld}
            accept={accept}
            className="content-files-dropbox"
            innerText={
              <div className="content-files-drop-text">
                <div>
                  <img src={`${NEW_IMAGE_PATH}picture.png`} />
                </div>
                <div>
                  {LocaleStrings.drag_and_drop} <br />
                  {LocaleStrings.or}{" "}
                  <span className="select-file">
                    {LocaleStrings.select_file}
                  </span>
                </div>
              </div>
            }
          />
          <div
            className="dynamic-options-actions-buttons"
            style={{ marginLeft: "6px" }}
          >
            {maxfile > 1 ? (
              index === existingFilesCount - 1 &&
              existingFilesCount < maxfile ? (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() =>
                    this.handleFileArray("add", existingFilesCount, name)
                  }
                >
                  <i className="fa fa-plus-circle"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => this.handleFileArray("remove", index, name)}
                >
                  <i className="fa fa-minus-circle"></i>
                </button>
              )
            ) : (
              ""
            )}
          </div>
        </div>
      );
    });
  };
  // Files field section end

  handleGroupTextField = (e, name, subname, index) => {
    let { exhibitorWorkingDynamicForm } = this.props;
    var value = e.target.value;

    if (
      exhibitorWorkingDynamicForm &&
      exhibitorWorkingDynamicForm.workingEventForm &&
      exhibitorWorkingDynamicForm.workingEventForm.length > 0
    ) {
      var checkEventFormGroup = _.filter(
        exhibitorWorkingDynamicForm.workingEventForm,
        (obj) => {
          return obj.key === "group" && obj.name === name;
        }
      );

      var newRecordArray = checkEventFormGroup[0].recordArray;

      newRecordArray[index][subname] = value;

      if (name === "products" && subname === "productcategory") {
        newRecordArray[index].productsubcategory = "";
        this.props.autofill(`productsubcategory[${index}]`, "");
      }
    }

    this.props.workingDynamicForm(exhibitorWorkingDynamicForm);
    this.setState({ update: !this.state.update }); // Don't remove [you need this to render dom [redux update do not render dom in react 18]]
  };

  handleGroupDateField = (e, name, subname, index) => {
    let { exhibitorWorkingDynamicForm } = this.props;
    let value =
      typeof e === "string"
        ? moment(e, DISPLAY_LOCAL_DATE_FORMAT).format("YYYY-MM-DD")
        : moment(e).format("YYYY-MM-DD");

    if (
      exhibitorWorkingDynamicForm &&
      exhibitorWorkingDynamicForm.workingEventForm &&
      exhibitorWorkingDynamicForm.workingEventForm.length > 0
    ) {
      var checkEventFormGroup = _.filter(
        exhibitorWorkingDynamicForm.workingEventForm,
        (obj) => {
          return obj.key === "group" && obj.name === name;
        }
      );

      var newRecordArray = checkEventFormGroup[0].recordArray;

      newRecordArray[index][subname] = value;
    }

    this.props.workingDynamicForm(exhibitorWorkingDynamicForm);
  };

  onProductImageSave = (index, name, img) => {
    let { exhibitorWorkingDynamicForm, filechanged } = this.props;

    var checkEventFormGroup = _.filter(
      exhibitorWorkingDynamicForm.workingEventForm,
      (obj) => {
        return obj.key === "group" && obj.name === name;
      }
    );

    var newRecordArray = checkEventFormGroup[0].recordArray;
    newRecordArray[index].productimages = img;

    this.props.workingDynamicForm(exhibitorWorkingDynamicForm);
    this.props.filesChanged({
      ischanged: filechanged.ischanged,
      groupfieldchanged: filechanged.groupfieldchanged
        ? filechanged.groupfieldchanged
        : false,
      productimagechanged: true,
    });
  };

  onProductImageChange = (imageAvailable) => {
    // if(imageAvailable !== undefined)
    //   this.setState({imageAvailable});
  };

  handleGroupArray = (action, index, name) => {
    let { exhibitorWorkingDynamicForm, filechanged } = this.props;

    var checkEventFormGroup = _.filter(
      exhibitorWorkingDynamicForm.workingEventForm,
      (obj) => {
        return obj.key === "group" && obj.name === name;
      }
    );
    // var findIndex = _.findIndex(exhibitorWorkingDynamicForm.workingEventForm, obj => { return obj.key === 'group' && obj.name === name});
    var newRecordArray = checkEventFormGroup[0].recordArray;
    var groupType = checkEventFormGroup[0].type;
    if (action === "add") {
      if (groupType === "products") {
        var proObj = {
          productimages: "",
          productcategory: "",
          productsubcategory: "",
          producttitle: "",
          productinfo: "",
        };
        newRecordArray.push(proObj);
      } else if (groupType === "coupons") {
        var couObj = {
          coupontitle: "",
          couponabout: "",
          couponecode: "",
          couponvalidtill: "",
        };
        newRecordArray.push(couObj);
      } else if (groupType === "deals") {
        var dealObj = { dealtitle: "", dealabout: "", dealvalidtill: "" };
        newRecordArray.push(dealObj);
      }
    } else {
      _.pullAt(newRecordArray, index);
    }

    this.props.workingDynamicForm(exhibitorWorkingDynamicForm);
    this.props.filesChanged({
      ischanged: filechanged.ischanged,
      groupfieldchanged: true,
      productimagechanged: filechanged.productimagechanged
        ? filechanged.productimagechanged
        : false,
    });

    this.setState({ update: !this.state.update }); // Don't remove [you need this to render dom [redux update do not render dom in react 18]]
  };

  renderGroups = (groupType, name) => {
    let {
      exhibitorWorkingDynamicForm,
      productCategories,
      productSubCategories,
    } = this.props;
    var recordArray = [];
    var maxEnteries = 1;
    var existingEntriesCount = 1;
    var groupfields = [];
    var categories = [];

    if (
      exhibitorWorkingDynamicForm &&
      exhibitorWorkingDynamicForm.workingEventForm &&
      exhibitorWorkingDynamicForm.workingEventForm.length > 0
    ) {
      var checkEventFormGroup = _.filter(
        exhibitorWorkingDynamicForm.workingEventForm,
        (obj) => {
          return obj.key === "group" && obj.name === name;
        }
      );

      recordArray = checkEventFormGroup[0].recordArray;
      maxEnteries = checkEventFormGroup[0].maxentries;
      groupfields = checkEventFormGroup[0].groupfields;
      existingEntriesCount = recordArray.length;
    }

    if (
      productCategories &&
      productCategories.data &&
      productCategories.data.length > 0
    ) {
      _.map(productCategories.data, (item, index) => {
        let cobj = { value: item.name, text: item.name };
        categories.push(cobj);
      });
    }

    if (recordArray.length > 0) {
      return _.map(recordArray, (item, index) => {
        var productImage = "";
        var subcategories = [];
        if (groupType === "products" && recordArray.length > 0) {
          var image = item.productimages;
          if (image != "") {
            var n = image.search(";base64,");
            if (n > 0) {
              productImage = image;
            } else {
              productImage = `${BASE_IMAGES_URL}/${image}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
            }
          }

          var categoryname = item.productcategory ? item.productcategory : "";
          var matchCat = _.filter(productCategories.data, (cat) => {
            return cat.name == categoryname;
          });
          var categoryid = matchCat.length > 0 ? matchCat[0].id : "";

          if (
            categoryid != "" &&
            productSubCategories &&
            productSubCategories.data &&
            productSubCategories.data.length > 0
          ) {
            var matchSubCate = _.filter(productSubCategories.data, (sc) => {
              return sc.categoryid == categoryid;
            });

            _.map(matchSubCate, (item, index) => {
              let scobj = { value: item.name, text: item.name };
              subcategories.push(scobj);
            });
          }
        }

        return (
          <div className="col-md-12" key={`key-${index}`}>
            <div className="row">
              {/* <Field
                            name={
                              groupfields && groupfields.length > 0
                                ? `${groupfields[1].name}[${index}]`
                                : ""
                            }
                            label={
                              groupfields && groupfields.length > 0
                                ? groupfields[1].label
                                : ""
                            }
                            placeholder="Select from options"
                            component={this.renderSelect}
                            mandatory={false}
                            opts={categories}
                            onChange={(e) =>
                              this.handleGroupTextField(
                                e,
                                name,
                                groupfields[1].name,
                                index
                              )
                            }
                          /> */}
              <div className="col-md-11 exhibitor-product-box">
                {groupType === "products" ? (
                  <div className="row">
                    <div className="col-sm-12 col-lg-4">
                      {/* <img src="../../../../../../style/images/dummy-image.png" style={{width:"100%"}}/> */}
                      <InlineCropper
                        width={200}
                        height={200}
                        border={10}
                        onImageSave={this.onProductImageSave.bind(
                          this,
                          index,
                          name
                        )}
                        onImageChange={this.onProductImageChange}
                        imagepath={productImage}
                        callfrom={"Exhibitor"}
                      />
                      <div className="image-subtitle-info">
                        {LocaleStrings.exhibitor_image_subtitle_info100}
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-8">
                      <div className="row">
                        <div className="col-md-12 p-0">
                          <Field
                            name={
                              groupfields && groupfields.length > 0
                                ? `${groupfields[3].name}[${index}]`
                                : ""
                            }
                            label={
                              groupfields && groupfields.length > 0
                                ? groupfields[3].label
                                : ""
                            }
                            placeholder="Enter title"
                            type="text"
                            component={this.renderFieldText}
                            mandatory="false"
                            maxlength={
                              groupfields && groupfields.length > 0
                                ? groupfields[3].maxlen
                                : ""
                            }
                            onChange={(e) =>
                              this.handleGroupTextField(
                                e,
                                name,
                                groupfields[3].name,
                                index
                              )
                            }
                            labelposition={LABEL_POSITION_TOP}
                          />
                        </div>
                        <div className="col-md-6 pl-0">
                          <Field
                            name={
                              groupfields && groupfields.length > 0
                                ? `${groupfields[1].name}[${index}]`
                                : ""
                            }
                            label={
                              groupfields && groupfields.length > 0
                                ? groupfields[1].label
                                : ""
                            }
                            placeholder="Select from options"
                            component={this.renderSelect}
                            mandatory={false}
                            opts={categories}
                            onChange={(e) =>
                              this.handleGroupTextField(
                                e,
                                name,
                                groupfields[1].name,
                                index
                              )
                            }
                            labelposition={LABEL_POSITION_TOP}
                          />
                        </div>
                        <div className="col-md-6 p-0">
                          <Field
                            name={
                              groupfields && groupfields.length > 0
                                ? `${groupfields[2].name}[${index}]`
                                : ""
                            }
                            label={
                              groupfields && groupfields.length > 0
                                ? groupfields[2].label
                                : ""
                            }
                            placeholder="Select from options"
                            component={this.renderSelect}
                            mandatory={false}
                            opts={subcategories}
                            onChange={(e) =>
                              this.handleGroupTextField(
                                e,
                                name,
                                groupfields[2].name,
                                index
                              )
                            }
                            labelposition={LABEL_POSITION_TOP}
                          />
                        </div>

                        <div className="col-md-12 p-0">
                          <Field
                            name={
                              groupfields && groupfields.length > 0
                                ? `${groupfields[4].name}[${index}]`
                                : ""
                            }
                            label={
                              groupfields && groupfields.length > 0
                                ? groupfields[4].label
                                : ""
                            }
                            placeholder="Enter about the item"
                            component={this.renderFieldTextarea}
                            mandatory="false"
                            maxLength={
                              groupfields && groupfields.length > 0
                                ? groupfields[4].maxlen
                                : ""
                            }
                            onChange={(e) =>
                              this.handleGroupTextField(
                                e,
                                name,
                                groupfields[4].name,
                                index
                              )
                            }
                            labelposition={LABEL_POSITION_TOP}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : groupType === "coupons" ? (
                  <div className="row">
                    <div className="col-md-12">
                      <Field
                        name={
                          groupfields && groupfields.length > 0
                            ? `${groupfields[0].name}[${index}]`
                            : ""
                        }
                        label={
                          groupfields && groupfields.length > 0
                            ? groupfields[0].label
                            : ""
                        }
                        placeholder="Enter title"
                        type="text"
                        component={this.renderFieldText}
                        mandatory="false"
                        maxlength={
                          groupfields && groupfields.length > 0
                            ? groupfields[0].maxlen
                            : ""
                        }
                        onChange={(e) =>
                          this.handleGroupTextField(
                            e,
                            name,
                            groupfields[0].name,
                            index
                          )
                        }
                        labelposition={LABEL_POSITION_TOP}
                      />
                    </div>
                    <div className="col-md-12">
                      <Field
                        name={
                          groupfields && groupfields.length > 0
                            ? `${groupfields[1].name}[${index}]`
                            : ""
                        }
                        label={
                          groupfields && groupfields.length > 0
                            ? groupfields[1].label
                            : ""
                        }
                        placeholder="Enter about the item"
                        component={this.renderFieldTextarea}
                        mandatory="false"
                        maxLength={
                          groupfields && groupfields.length > 0
                            ? groupfields[1].maxlen
                            : ""
                        }
                        onChange={(e) =>
                          this.handleGroupTextField(
                            e,
                            name,
                            groupfields[1].name,
                            index
                          )
                        }
                        labelposition={LABEL_POSITION_TOP}
                      />
                    </div>
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <Field
                            name={
                              groupfields && groupfields.length > 0
                                ? `${groupfields[3].name}[${index}]`
                                : ""
                            }
                            label={
                              groupfields && groupfields.length > 0
                                ? groupfields[3].label
                                : ""
                            }
                            labelposition={LABEL_POSITION_TOP}
                            component={this.renderDatePicker}
                            mandatory="false"
                            //minDate={new Date(moment().format("YYYY,MM,DD"))}
                            //minDate={format(new Date().getDate(),DATE_FORMAT_FNS)}
                            // selected={moment()}
                            minDate={subDays(new Date(), 0)}
                            onChange={(e) =>
                              this.handleGroupDateField(
                                e,
                                name,
                                groupfields[3].name,
                                index
                              )
                            }
                          />
                        </div>
                        <div className="col-md-6" style={{ padding: 0 }}>
                          <Field
                            name={
                              groupfields && groupfields.length > 0
                                ? `${groupfields[2].name}[${index}]`
                                : ""
                            }
                            label={
                              groupfields && groupfields.length > 0
                                ? groupfields[2].label
                                : ""
                            }
                            placeholder="Enter coupon code"
                            type="text"
                            component={this.renderFieldText}
                            mandatory="false"
                            maxlength={
                              groupfields && groupfields.length > 0
                                ? groupfields[2].maxlen
                                : ""
                            }
                            onChange={(e) =>
                              this.handleGroupTextField(
                                e,
                                name,
                                groupfields[2].name,
                                index
                              )
                            }
                            labelposition={LABEL_POSITION_TOP}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : groupType === "deals" ? (
                  <div className="row">
                    <div className="col-md-12">
                      <Field
                        name={
                          groupfields && groupfields.length > 0
                            ? `${groupfields[0].name}[${index}]`
                            : ""
                        }
                        label={
                          groupfields && groupfields.length > 0
                            ? groupfields[0].label
                            : ""
                        }
                        placeholder="Enter title"
                        type="text"
                        component={this.renderFieldText}
                        mandatory="false"
                        maxlength={
                          groupfields && groupfields.length > 0
                            ? groupfields[0].maxlen
                            : ""
                        }
                        onChange={(e) =>
                          this.handleGroupTextField(
                            e,
                            name,
                            groupfields[0].name,
                            index
                          )
                        }
                        labelposition={LABEL_POSITION_TOP}
                      />
                    </div>
                    <div className="col-md-12">
                      <Field
                        name={
                          groupfields && groupfields.length > 0
                            ? `${groupfields[1].name}[${index}]`
                            : ""
                        }
                        label={
                          groupfields && groupfields.length > 0
                            ? groupfields[1].label
                            : ""
                        }
                        placeholder="Enter about the item"
                        component={this.renderFieldTextarea}
                        mandatory="false"
                        maxLength={
                          groupfields && groupfields.length > 0
                            ? groupfields[1].maxlen
                            : ""
                        }
                        onChange={(e) =>
                          this.handleGroupTextField(
                            e,
                            name,
                            groupfields[1].name,
                            index
                          )
                        }
                        labelposition={LABEL_POSITION_TOP}
                      />
                    </div>
                    <div className="col-md-12">
                      <Field
                        name={
                          groupfields && groupfields.length > 0
                            ? `${groupfields[2].name}[${index}]`
                            : ""
                        }
                        label={
                          groupfields && groupfields.length > 0
                            ? groupfields[2].label
                            : ""
                        }
                        labelposition={LABEL_POSITION_TOP}
                        component={this.renderDatePicker}
                        mandatory="false"
                        // selected={moment()}
                        //minDate={new Date(moment().format("YYYY,MM,DD"))}
                        minDate={subDays(new Date(), 0)}
                        onChange={(e) =>
                          this.handleGroupDateField(
                            e,
                            name,
                            groupfields[2].name,
                            index
                          )
                        }
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-1">
                <div className="dynamic-options-actions-buttons">
                  {maxEnteries > 1 ? (
                    index === existingEntriesCount - 1 &&
                    existingEntriesCount < maxEnteries ? (
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() =>
                          this.handleGroupArray(
                            "add",
                            existingEntriesCount,
                            name
                          )
                        }
                      >
                        <i className="fa fa-plus-circle"></i>
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() =>
                          this.handleGroupArray("remove", index, name)
                        }
                      >
                        <i className="fa fa-minus-circle"></i>
                      </button>
                    )
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      });
    }
  };
  // Group field section end

  render() {
    let { initialValues, toEdit, settingData, ticketList } = this.props;
    let eventForm =
      settingData &&
      settingData.length > 0 &&
      settingData[0].event_forms_by_exhibitorformid
        ? JSON.parse(settingData[0].event_forms_by_exhibitorformid.formjson)
        : [];

    if (toEdit && initialValues.comesfrom == "ticket") {
      var matchedTicket = _.filter(ticketList, (ticket) => {
        return ticket.id == initialValues.ticketid;
      });

      if (matchedTicket.length > 0 && matchedTicket[0].event_forms_by_formid) {
        eventForm = JSON.parse(matchedTicket[0].event_forms_by_formid.formjson);
      }
    }

    return (
      <div className="otherdetailsform">
        {_.map(eventForm, (form, index) => {
          var name = form.name;
          var filetype = "";
          var accept = "";
          if (form.key == "file") {
            filetype = form.filetype;
            if (filetype == "image") {
              accept = "image/*";
            } else if (filetype == "video") {
              accept = "video/*";
            } else if (filetype == "audio") {
              accept = "audio/*";
            } else if (filetype == "document") {
              accept = "application/*";
              // accept = 'application/pdf,application/vnd.ms-excel,application/msword,application/zip';
            }
            // else {
            //   accept = '*';
            // }
          }

          return (
            <div key={index}>
              {form.key == "textinput" || form.key == "numberinput" ? (
                <Field
                  name={name}
                  label={form.label}
                  type={form.key == "textinput" ? "text" : "number"}
                  component={
                    form.name === "whatsapp"
                      ? this.renderNumberWithCountryField
                      : this.renderFieldText
                  }
                  mandatory={"false"}
                  maxlength={form.maxlen}
                  labelposition={LABEL_POSITION_TOP}
                />
              ) : form.key == "textarea" ? (
                <Field
                  name={name}
                  label={form.label}
                  component={this.renderFieldTextarea}
                  mandatory={false}
                  maxlength={form.maxlen}
                  labelposition={LABEL_POSITION_TOP}
                />
              ) : form.key == "checkboxes" ? (
                <Field
                  name={name}
                  label={form.label}
                  type="checkbox"
                  component={this.renderCheckbox}
                  mandatory={false}
                  opts={form.options}
                />
              ) : form.key == "radiobuttons" ? (
                <div className="form-group row">
                  <label className="control-label-top col-sm-12">
                    {form.label}
                  </label>
                  <div className="col-sm-12 col-sm-offset-0">
                    {_.map(form.options, (opt, index) => {
                      return (
                        <div key={index} style={{ display: "flex" }}>
                          <Field
                            name={name}
                            label={opt.text}
                            value={opt.value}
                            type="radio"
                            component={this.renderFieldRadio}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : form.key == "dropdown" ? (
                <Field
                  name={name}
                  label={form.label}
                  placeholder={LocaleStrings.exhibitor_select_from_options}
                  component={this.renderSelect}
                  mandatory={false}
                  opts={form.options}
                  labelposition={LABEL_POSITION_TOP}
                />
              ) : form.key == "datepicker" ? (
                <>
                  <Field
                    name={name}
                    label={form.label}
                    component={this.renderDatePicker}
                    mandatory={false}
                    // [Before chnaging to date-fns] selected={moment()}
                    selected={format(new Date(), DATE_FORMAT_FNS)}
                  />
                </>
              ) : form.key == "hyperlink" ? (
                <div className="form-group row">
                  <label className="control-label-top col-sm-12">
                    {" "}
                    {form.label}{" "}
                  </label>
                  <a
                    href={form.link}
                    target="blank"
                    className="col-sm-12 col-sm-offset-0"
                    style={{
                      padding: "6px 14px",
                      fontWeight: "bold",
                      color: "#2676ea",
                    }}
                  >
                    {form.link}
                  </a>
                </div>
              ) : form.key == "label" ? (
                <label>{form.label}</label>
              ) : form.key == "paragraph" ? (
                <p>{form.label}</p>
              ) : form.key == "file" ? (
                <div className="form-group row">
                  <label className="control-label-top col-sm-12">
                    {" "}
                    {form.label}{" "}
                  </label>
                  <div
                    className="row"
                    style={{ paddingLeft: 0, paddingRight: 0 }}
                  >
                    {this.renderFiles(accept, name)}
                  </div>
                </div>
              ) : form.key == "group" ? (
                <div className="form-group row">
                  <label className="control-label-top col-sm-12">
                    {" "}
                    {form.label}{" "}
                  </label>
                  {this.renderGroups(form.type, name)}
                </div>
              ) : (
                ""
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

class ExhibitorContactForm extends BaseComponent {
  render() {
    return (
      <div className="exhibitorcontactform">
        <Field
          name="email"
          label={LocaleStrings.exhibitor_label_email}
          placeholder={LocaleStrings.exhibitor_placeholder_email}
          type="email"
          component={this.renderFieldText}
          mandatory="false"
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="phone"
          label={LocaleStrings.exhibitor_label_phone}
          placeholder={LocaleStrings.exhibitor_placeholder_phone}
          type="tel"
          component={this.renderFieldText}
          mandatory="false"
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="weblink"
          label={LocaleStrings.exhibitor_label_website}
          placeholder={LocaleStrings.exhibitor_placeholder_website}
          type="url"
          component={this.renderFieldText}
          mandatory="false"
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="facebook"
          label={LocaleStrings.exhibitor_label_facebook}
          placeholder={LocaleStrings.exhibitor_placeholder_facebook}
          type="url"
          component={this.renderFieldText}
          mandatory="false"
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="linkedin"
          label={LocaleStrings.exhibitor_label_linkedin}
          placeholder={LocaleStrings.exhibitor_placeholder_linkedin}
          type="url"
          component={this.renderFieldText}
          mandatory="false"
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="twitter"
          label={LocaleStrings.exhibitor_label_twitter}
          placeholder={LocaleStrings.exhibitor_placeholder_twitter}
          type="url"
          component={this.renderFieldText}
          mandatory="false"
          labelposition={LABEL_POSITION_TOP}
        />
      </div>
    );
  }
}
